import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "mt-2 fw-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "text-center mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_pointer = _resolveComponent("icon-pointer")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_icon_pointer)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "La tua iscrizione AuraClub",
          text: "La tua iscrizione AuraClub"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Con l'iscrizione AuraClub mantieni attivo il tuo profilo per avere tutti i vantaggi riservati ai soci",
          text: "Con l'iscrizione AuraClub mantieni attivo il tuo profilo per avere tutti i vantaggi riservati ai soci"
        })
      ])
    ]),
    (_ctx.$route.fullPath != '/network/clubSubscription')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "btn btn-primary",
              to: "/network/clubSubscription"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dettaglio",
                  text: "Dettaglio"
                })
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}